import React, { useState, Suspense, useEffect } from "react";
import { AnimatePresence, useCycle } from "framer-motion";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import Loader from "../Helpers/Loader";

const SidePanel = React.lazy(() => import("../SidePanel/SidePanel"));

const App = ({cards, containerId}) => {

	const [data, setData] = useState(cards);
	const [selectedItem, setSelectedItem] = useState("");
	const [open, cycleOpen] = useCycle(false, true);

	useEffect(() => {
		if (open === true) {
			document.body.classList.add("panel-open");
		} else {
			document.body.classList.remove("panel-open");
		}
	}, [open]);

	//useEffect responsible for displaying the sidepanel from a sharable url
	useEffect(() => {
		if (data.length > 0) {
			if (window.location.hash) {
				// if there is a hash in the url we first extract the section Id that it is related to
				let trimmedIncomingContainerId = window.location.search.replace(
					"?",
					""
				);
				let parsedContainerId = parseInt(trimmedIncomingContainerId);

				//then we extract the slug of the panel item that is shared
				let trimmedIncomingPanel = window.location.hash.replace("#", "");

				if (parsedContainerId == containerId) {
					// find the panel we want from the panel array using the trimmed hash
					let selectedPanel = data.find(
						(panel) => panel.slug == trimmedIncomingPanel
					);

					// we open the sidePanel related to that specific storyline item that is matches the specific section id
					if (selectedPanel) {
						toggleSidePanel(selectedPanel);
					}
				}
			}
		}
	}, [data]);

	const toggleSidePanel = (item) => {
		if (item) {
			cycleOpen(true);
			setSelectedItem(item);
		} else {
			cycleOpen(false);
			setSelectedItem({});
			window.history.pushState({}, "", window.location.pathname);
		}
	};

	const updateUrl = (item) => {
		let urlParams = "";
		if (item) {
			// we use the hash param in window.location to store the performer slug
			urlParams = "?" + item.containerId + "#" + item.slug;
		}
		window.history.pushState(null, "", urlParams);
	};

	const itemList = data.map((item) => {
		return (
			<PanelTitle key={item.id} aria-label={`Open ${item.title} panel`} aria-roledescription={"Open panel"} aria-controls={"panel"} id={item.id} tabIndex={0} onClick={() => {toggleSidePanel(item);
				updateUrl(item);}}>{item.title}</PanelTitle>
		)
	});

	return (
		<>
			<Suspense fallback={<Loader />}>
				<PanelTitleList>
					{itemList}
				</PanelTitleList>
				<AnimatePresence>
					{open && selectedItem && <SidePanel
						selectedContent={selectedItem}
						toggleSidePanel={toggleSidePanel}
						handleNext={false}
						handlePrevious={false}
					/> }
				</AnimatePresence>
			</Suspense>
		</>
	);
};

export default App;

App.propTypes = {
	json: PropTypes.any,
};


const PanelTitleList = styled.ul`
	padding-left: 0 !important;
	margin: 0 !important;

	li:last-child {
		&::after {
			content: "";
			width: 100%;
			border-bottom: 0.1rem solid #D9D9D9;
			margin: 2.2rem auto;
			display: block;
		}
	  }
`;

const PanelTitle = styled.li`
	font-weight: 600;
	font-family: myriad-pro, helvetica, arial, sans-serif;
	font-size: 2.1rem;
	line-height: 2.7rem;
	display: flex;
	align-items: center;
	cursor: pointer;
	display: block;

	&:hover {
		text-decoration: underline;
	}
	&::before {
        content: "";
        width: 100%;
        border-bottom: 0.1rem solid #D9D9D9;
        margin: 2.2rem auto;
        display: block;
    }

`;
